import { render, staticRenderFns } from "./CoursesCloning.vue?vue&type=template&id=458ebf56"
import script from "./CoursesCloning.vue?vue&type=script&lang=js"
export * from "./CoursesCloning.vue?vue&type=script&lang=js"
import style0 from "./CoursesCloning.vue?vue&type=style&index=0&id=458ebf56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports